import { useAuth } from '@/hooks/useAuth';
import { useEffect, useState, useCallback } from "react";
import { MonthYearPicker } from "@/components/common/MonthYearPicker";
import { supabase } from "@/integrations/supabase/client";

interface MobileDashboardHeaderProps {
  onTransactionSuccess: () => void;
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  onBalanceClick?: () => void;
}

export function MobileDashboardHeader({ onTransactionSuccess, selectedDate, onDateChange, onBalanceClick }: MobileDashboardHeaderProps) {
  const [totalBalance, setTotalBalance] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount);
  };

  const fetchBalanceAndGrowth = useCallback(async () => {
    try {
      if (user == null) return;
      // Buscar saldo total das contas
      const { data: contas, error: contasError } = await supabase
        .from("contas")
        .select("saldo_atual")
        .eq('user_id', user.id)
        .eq("ativo", true);

      if (contasError) throw contasError;

      const total = (contas || []).reduce((sum, conta) => {
        return sum + (conta.saldo_atual || 0);
      }, 0);

      setTotalBalance(total);

    } catch (error) {
      console.error("Erro ao carregar dados do dashboard:", error);
      setTotalBalance(0);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchBalanceAndGrowth();
  }, [selectedDate, fetchBalanceAndGrowth]);

  return (
    <>
      <div className="mx-4 mb-2 pt-2">
        <div className="bg-gradient-to-br from-primary to-secondary rounded-2xl p-6 text-white shadow-medium">
          <div className="mb-4">
            <MonthYearPicker selectedDate={selectedDate} onDateChange={onDateChange} />
          </div>
          <div className="mb-0 cursor-pointer" onClick={onBalanceClick}>
            <p className="text-primary-foreground/80 text-body-sm mb-1">Saldo Total</p>
            <p className="text-2xl font-bold tabular-nums">
              {loading ? "Carregando..." : formatCurrency(totalBalance)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}